/* import { getXmlValueByPath } from '@/utils/getXmlValueByPath';
import store from '@/store'; // Importiere den Vuex-Store
import { replaceTextinRule } from './replaceRuleText';

export async function replacePlaceholders(text, preview, data) {
    const xPathPlaceholders = store.state.xPathPlaceholders;

    Object.keys(xPathPlaceholders).forEach(placeholder => {
        const mapping = xPathPlaceholders[placeholder];
        if(!mapping.xpath) return text;
        let value;
        if(preview) {
        value = await getXmlValueByPath(mapping.xpath);
        } else {
        value = `<span class="XPATHContainer" contenteditable="false" title="${mapping.xpath}"> &lt;xsl:value-of select="${mapping.xpath}"/&gt;</span>`
        }
        const regex = new RegExp(`\\[\\[${mapping.placeholder}\\]\\]`, 'g');
        text = text.replace(regex, value);
    });
    if(preview){
    text= text.replace(/%%(.*?)%%/g, (match, placeholder) => {
        const newValue = replaceTextinRule(placeholder, data); 
        console.log(newValue)
        return newValue !== undefined ? newValue : match; 
    });
    }else{
        text= text.replace(/%%(.*?)%%/g, () => {
            return data.map(rule => {
                if (rule.operator == 'else') return '';
                const xsl = `${xPathPlaceholders.find(p => p.placeholder === rule.statement)?.xpath ||'' }${rule?.operator || ''}${rule?.value || ''}`;
                return `<xsl:when test="${xsl}">
                <div class="placeHolderDescription">${rule?.conditionName || 'description'}</div>
                <div class="placeHolder" contenteditable="false">
                ${rule.value}
                </div>
                </xsl:when>`;
                }).join('');})
    }
    return text;
} */
    import { getXmlValueFE} from '@/utils/getXmlValueFE';
    import store from '@/store'; // Importiere den Vuex-Store
    import { replaceTextinRule } from './replaceRuleText';
    
    export function replacePlaceholders(text, preview, data, index) {
      const xPathPlaceholders = store.state.xPathPlaceholders;
    
      // Verwende for...of statt Object.keys(...).forEach(...)
      for (const key of Object.keys(xPathPlaceholders)) {
        const mapping = xPathPlaceholders[key];
        if (!mapping.xpath) continue; // Falls kein xpath vorhanden ist, überspringen
        let value;
        if (preview) {
          value = getXmlValueFE(mapping.xpath, index);
        } else {
          value = `<span class="XPATHContainer" contenteditable="false" title="${mapping.xpath}"> &lt;xsl:value-of select="${mapping.xpath}"/&gt;</span>`;
        }
        const regex = new RegExp(`\\[\\[${mapping.placeholder}\\]\\]`, 'g');
        text = text.replace(regex, value);
      }
    
      if (preview) {
        text = text.replace(/%%(.*?)%%/g, (match, placeholder) => {
          const newValue = replaceTextinRule(placeholder, data);
          console.log(newValue);
          return newValue !== undefined ? newValue : match;
        });
      } else {
        text = text.replace(/%%(.*?)%%/g, () => {
          return data
            .map(rule => {
              if (rule.operator == 'else') return '';
              // Angenommen, xPathPlaceholders ist ein Array; hier könnte ggf. angepasst werden,
              // wenn xPathPlaceholders ein Objekt ist, müsstest du eine andere Methode verwenden.
              const xsl =
                `${xPathPlaceholders.find(p => p.placeholder === rule.statement)?.xpath || ''}` +
                `${rule?.operator || ''}` +
                `${rule?.value || ''}`;
              return `<xsl:when test="${xsl}">
                        <div class="placeHolderDescription">${rule?.conditionName || 'description'}</div>
                        <div class="placeHolder" contenteditable="false">
                          ${rule.value}
                        </div>
                      </xsl:when>`;
            })
            .join('');
        });
      }
      return text;
    }
    
